import COMPANY_ZUS from '../../../api/companyZusApi.js';

const baseCompanyZus = () => ({
  person: null,
  period: '',
  payment_deadline_date: '',
  payment_date: '',
  include_in_tax_calculation: true,
  booked_to_kpir: false,
  _book_to_kpir: false,
  zus_contribution_sum: '0,00',
  pit_4_info_attached: false,
  pit_4_amount: null,
  tax_account_number: null,
  zusfund: [],
  zusfundforemployees: [],
});


const state = {
  zus: baseCompanyZus(),
};

const getters = {
  zusFundsByValueObject: state => {
    return state
      .zus
      .zusfund
      .reduce(
        (zusfunds, { zusfundtype, value }) => {
          zusfunds[zusfundtype] = value;
          return zusfunds;
        },
        {},
      );
  },
  zusFundsEmployeeByValueObject: state => {
    return state
      .zus
      .zusfundforemployees
      .reduce(
        (zusfunds, { zusfundtype, value }) => {
          zusfunds[zusfundtype] = value;
          return zusfunds;
        },
        {},
      );
  },
};

const actions = {
  resetCompanyZusToBase({ commit, state }, payload = {}) {
    commit('setZus', {
      ...baseCompanyZus(),
      ...payload,
    });
  },
  indexCompanyZus({ commit, state }, url) {
    return new Promise((resolve, reject) => {
      COMPANY_ZUS.ZUS.index(url).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  showCompanyZus({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      COMPANY_ZUS.ZUS.show(id).then(response => {
        commit('setZus', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  deleteCompanyZus({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      COMPANY_ZUS.ZUS.delete(id).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  storeCompanyZus({ commit, state }) {
    return new Promise((resolve, reject) => {
      COMPANY_ZUS.ZUS.store({
        zusemployer: state.zus,
      }).then(response => {
        commit('setZus', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  updateCompanyZus({ commit, state }) {
    return new Promise((resolve, reject) => {
      COMPANY_ZUS.ZUS.update(state.zus).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
};

const mutations = {
  updateZus(state, payload) {
    state.zus = {
      ...state.zus,
      ...payload,
    };
  },
  setZus(state, zus) {
    state.zus = zus;
  },
  setZusFundByValueObject(state, zusfunds = {}) {
    if (state.zus.id !== undefined) {
      state.zus = {
        ...state.zus,
        ...{
          zusfund: state.zus.zusfund
            .map(curr => {
              if (zusfunds[curr.zusfundtype] !== undefined) {
                return {
                  ...curr,
                  value: zusfunds[curr.zusfundtype],
                };
              }
              return curr;
            }),
        },
      };
    } else {
      const zusfund = Object.keys(zusfunds).map(item => ({
        'zusfundtype': parseInt(item),
        'value': zusfunds[item],
      }));
      state.zus = {
        ...state.zus,
        ...{ zusfund },
      };
    }
  },
  setZusFundEmployeeByValueObject(state, zusfunds = {}) {
    if (state.zus.id !== undefined) {
      state.zus = {
        ...state.zus,
        ...{
          zusfundforemployees: state.zus.zusfundforemployees
            .map(curr => {
              if (zusfunds[curr.zusfundtype] !== undefined) {
                return {
                  ...curr,
                  value: zusfunds[curr.zusfundtype],
                };
              }
              return curr;
            }),
        },
      };
    } else {
      const zusfundforemployees = Object.keys(zusfunds).map(item => ({
        'zusfundtype': parseInt(item),
        'value': zusfunds[item],
      }));
      state.zus = {
        ...state.zus,
        ...{ zusfundforemployees },
      };
    }

  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
